import { apiClient } from './client';
import type { ChangePasswordRequest, KlienMeResponse, UpdateKlienRequest } from '../types/api';

export const klienApi = {
  me: () => apiClient.get<KlienMeResponse>('/klien/me', true),

  updateMe: (body: UpdateKlienRequest) =>
    apiClient.put<{ message: string }>('/klien/me', body, true),

  changePassword: (body: ChangePasswordRequest) =>
    apiClient.post<{ message: string }>('/klien/change-password', body, true),
};
